import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PartnerDto } from 'src/app/core/modele/partnerDto';
import { ThemeDetectorService } from 'src/app/core/service/theme-detector.service';
import { TlumaczeniaService, LANGS } from 'src/app/core/tlumaczenia/serwisy/tlumaczenia.service';
import { WcagUstawieniaModel } from 'src/app/funkcjonalnosci/wcag/modele/wcag-ustawienia-model';
import { WcagUstawieniaService, TYP_FILTRA } from 'src/app/funkcjonalnosci/wcag/serwisy/wcag-ustawienia.service';

@Component({
  selector: 'app-logo-partnera',
  templateUrl: './logo-partnera.component.html',
  styleUrls: ['./logo-partnera.component.scss']
})
export class LogoPartneraComponent implements OnInit, OnChanges {

  @Input() partner!: PartnerDto;

  isDark = false;
  wcagUstawienia: WcagUstawieniaModel;
  jezykUstawienia: string;
  toolTip: string = '';
  src: string = '';
  alt: string = '';
  ariaLabel: string = '';
  /**
   * Kostruktor
   * @param wcagService - serwis wcag
   * @param tlumaczeniaService - serwis tłumaczeń
   */
  constructor(private wcagService: WcagUstawieniaService,
    private tlumaczeniaService: TlumaczeniaService,
    private themeService: ThemeDetectorService,
  ) {
    this.wcagUstawienia = wcagService.pobierzDomyslneUstawienia();
    this.jezykUstawienia = tlumaczeniaService.pobierzAktualnyJezyk();

  }

  /**
   * Cykl życia komponentu inicjalizacja
   */
  ngOnInit(): void {
    this.isDark = this.themeService.isSystemDarkMode();
    this.ustawLogo();
    this.wcagService.getZmianaUstawienSubject().subscribe((ustawienia) => {
      this.wcagUstawienia = ustawienia;
      this.ustawLogo();
    });
    this.tlumaczeniaService.getZmianaJezykaSubject().subscribe((jezyk) => {
      this.jezykUstawienia = jezyk;
      this.ustawLogo();
    });
  }
  ngOnChanges(): void {
    if (this.partner) {
      this.ustawLogo();
    }
  }
  /**
   * Ustawia logo zależnie od wybranej opcji wcag
   */
  private ustawLogo(): void {
    if (this.jezykUstawienia === LANGS.PL) {
      this.src = this.partner.logoSrc;
      this.toolTip = this.partner.nazwa + ', link otwiera się w nowej karcie';
      this.alt = this.partner.alt!;
      this.ariaLabel = this.partner.nazwa + ' - przejdź do strony głównej. Link otwiera się w nowej karcie.';
    } else {
      this.src = this.partner.logoSrcEn!;
       this.toolTip = this.partner.nazwa + ', link opens in a new tab';
      this.alt = this.partner.altEn!;
      this.ariaLabel = this.partner.nazwa + ' - go to the home page. Link opens in a new tab.';
    }
  }

  klikEnter(): void {
    window.open(this.partner.linkDoStrony, '_blank');
  }

}
